import { makeStyles } from '@material-ui/core/styles'

export const learningCenterStyles = makeStyles((theme) => ({
  gridContainer: {
    padding: theme.spacing('5px', 1),
    marginBottom: 5,
  },
  upcomingWorkShopListContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& > div:nth-child(even)': {
      background: theme.palette.components.listBackground,
    },
  },
  divider: {
    borderTop: '1px solid',
    width: '100%',
    marginBottom: '1px',
    color:
      theme.palette.type === 'light'
        ? theme.palette.base.gray
        : theme.palette.base.white,
  },
  allWorkshopsButton: {
    color: theme.palette.base.black,
    marginTop: 5,
    marginBottom: 5,
    fontSize: 15,
  },
  allWorkshopsFooterButton: {
    border: theme.palette.base.red,
    color: theme.palette.base.black,
    fontSize: 12,
  },
  buttonLink: {
    width: '100%',
  },
  boldText: {
    fontWeight: 'bold',
  },
  boxContainer: {
    height: 210,
    overflowY: 'auto',
  },
  upcomingWorkshopsTitle: {
    width: '100%',
    textAlign: 'center',
    fontWeight: 'bold',
    padding: '5px 0px',
  },
  eventContainer: {
    padding: '5px 0px',
  },
  eventNameContainer: {
    flex: 1,
    padding: '2px',
  },
  eventName: {
    color: theme.palette.components.linkTextAlt,
    '&:hover': {
      textDecoration: 'underline',
    },
    fontWeight: 'bold',
  },
  eventDateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    flex: 1,
  },
  allWorkshopsContainer: {
    display: 'flex',
    width: '100%',
    margin: '5px 0',
    justifyContent: 'center',
  },
  footerLinksContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-evenly',
    marginTop: 'auto',
  },
}))

export default learningCenterStyles
